<ds-configuration-search-page configuration="workflowAdmin" [context]="context"></ds-configuration-search-page>
